<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-24 13:14:36
 * @LastEditors: Wang Bin <email: binnuo1109@163.com> <tel: 13937670602>
 * @LastEditTime: 2021-07-05 16:20:53
 * @Description: 富文本组件
 * @FilePath: /hsylc2021/src/components/form/Rich/index.vue
-->
<template>
  <div class="component-editor" :class="computedClass">
    <QuillEditor @blur="handleBlur" ref="quill" @focus="handleFocus" :content="value" :disabled="disabled" :options="OPTIONS" @change="handleOnChange" />
  </div>
</template>
<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.snow.css';
/**
 * 富文本组件
 * @module Rich
 */
export default {
  name: 'Rich',
  components: {
    QuillEditor: quillEditor
  },
  /**
   * @prop {String} value v-model绑定数据
   * @prop {String} className 外部class
   */
  props: {
    value: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  /**
   * @prop {Object} 计算后富文本组件参数
   * @prop {Object} class对象
   */
  computed: {
    OPTIONS: function() {
      let ret = {};
      ret.modules = {};
      ret.modules.toolbar = this.TOOL_BAR_OPTIONS;
      return ret;
    },
    computedClass() {
      let ret = {};
      ret[this.className] = true;
      return ret;
    }
  },
  /**
   * @prop {Object} TOOL_BAR_OPTIONS 富文本组件头工具
   */
  data: () => ({
    TOOL_BAR_OPTIONS: {
      container: [
        ['bold', 'italic'],
        [{ header: '1' }, { header: '2' }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }]
        // ['image']
      ]
    }
  }),
  methods: {
    /**
     * @event input 输入事件
     */
    /**
     * @description change事件
     * @function handleOnChange
     * @param {Object} params 参数对象
     */
    handleOnChange: function(params) {
      this.$emit('input', params.html);
    },
    /**
     * @event blur 失焦暴露
     */
    handleBlur: function() {
      this.$emit('blur');
    },
    /**
     * @event focus 聚焦事件
     */
    handleFocus(event) {
      this.$emit('focus', event);
    }
  }
};
</script>
<style lang="less" src="./index.less"></style>
